

import React from 'react'
import Scroll from 'react-scroll'
import Translation from '../../General/Translation'
import TrailerFormatItem from '../../TrailerFormatItem'
import OverviewInterscroller from '../OverviewInterscroller'

let Element = Scroll.Element


const GridTrailerItems = ({
    items, 
    itemsData, 
    itemOnClick, 
    movieInformationOrder, 
    activeItem, 
    playTrailerIems,
    additionalScrollName, 
    isConnectedFast, 
    translation, 
    interscrollerId,
    isMobile,
    queryStringValues,
    interscrollerType,
    interscrollerWeischerAds,
    interscrollerAdvertisements,
    setTrailerItemsInView
}) => (
    0 === items.length ? (<h3 className="no-movie title-xlarge-theatre"><Translation id="ThereCurrentlyNoFilmsTypes" trans={translation}>Zurzeit laufen keine Filme dieser Art</Translation></h3>) : (
        items.map((itemId, index) => {
            let itemData = null

            let itemOrder = 0

            if(activeItem) {
                if(index < movieInformationOrder) {
                    itemOrder = index
                } else {
                    itemOrder = index + 1
                }
            }
        
            const styles = {
                order: itemOrder
            }

            if(interscrollerType && itemId === interscrollerId) {
                return <OverviewInterscroller
                    key={index}
                    interscrollerType={interscrollerType}
                    interscrollerWeischerAds={interscrollerWeischerAds}
                    interscrollerAdvertisements={interscrollerAdvertisements}
                    styles={styles}
                />
            } else {
                itemData = itemsData[itemId]

                const trailerKey = index.toString()
                const shouldPlayTrailer = playTrailerIems.hasOwnProperty(trailerKey) && playTrailerIems[trailerKey].play
    
                return (
                    <div className="order-wrapper" style={styles} key={index}>
                        <Element name={itemId + additionalScrollName}></Element>
    
                        <TrailerFormatItem
                            itemID={itemId}
                            showAttributes={true}
                            index = {index}
                            queryStringValues={queryStringValues}
                            isMobile={isMobile}
                            showFSK={true}
                            itemData={itemData}
                            scrollToPosition={itemId + additionalScrollName}
                            onClickItem={itemOnClick}
                            translation={translation}
                            shouldPlayTrailer={shouldPlayTrailer}
                            trailerAutoplay={true}
                            isConnectedFast={isConnectedFast}
                            setTrailerItemsInView={setTrailerItemsInView}
                        />
    
                        <Element name={itemId + additionalScrollName + ' openMovieInformation'}></Element>
                    </div>
                )
            }
        })
    )
)


export default GridTrailerItems